<template>
  <div class="layout-header">
    <a href="/" target="_blank" class="login-img" style="width: 199px;"><img src="../../assets/images/logo.png" /></a>
    <div class="hd-right"  :class="{
       'hd-right-icon': showMobileIcon,
       'justify-end': showMobileIcon && !showMobileMenu,
       'align-start': showMobileIcon && showMobileMenu
     }"  ref="menuContainerRef">
      <div v-if="showMobileIcon" class="hamburger-icon" @click.stop="toggleMobileMenu">
        <AlignRightOutlined />
      </div>
      <ul v-if="!showMobileIcon" class="hd-right-ul">
        <li v-for="item in data.dataList" :key="item.id" @click.stop="clickTab(String(item.id))">
          <a href="javascript:void(0)">{{
            item.channel_name
            }}</a>
          <header-select :items="item" v-if="data.tabHoverId == String(item.id)" :type="item.id"></header-select>
        </li>
      </ul>
       <ul v-if="showMobileMenu" class="hd-right-ul" :class="{ 'mobile-menu': showMobileMenu }">
        <li v-for="item in data.dataList" :key="item.id" @click.stop="clickTab(String(item.id))">
          <a href="javascript:void(0)">{{
            item.channel_name
            }}</a>
          <header-select :items="item" v-if="data.tabHoverId == String(item.id)" :type="item.id"></header-select>
        </li>
      </ul>

      <div class="hd-right-left">
        <div class="icon-div">
        </div>
        <a-dropdown placement="bottomRight">
          <div class="hd-right-dropdown">
            <div class="hd-right-user" @click.prevent>
              <!-- <span class=""></span> -->

              <img v-if="$store.state.userInfo.head_image" :src="$store.state.userInfo.head_image" alt="" width="35"
                style="height: 35px;border-radius: 50%;">
              <img v-else src="@/assets/images/avatar.png" alt="" width="35" style="height: 35px;border-radius: 50%;">
              <div style="margin: 0 5px;">{{ $store.state.userInfo.fullname }} </div>
              <img src="@/assets/images/down.png" alt="" width="15">
            </div>

          </div>
          <template #overlay>
            <a-menu>
              <a-menu-item style="background: #f5f5f5;cursor: default;">
                <div>{{ $store.state.userInfo.email }}</div>
                <div>{{ $store.state.userInfo.company }}</div>
              </a-menu-item>
              <a-menu-item @click="clickInfo">
                <span>基本资料</span>
              </a-menu-item>
              <a-menu-item @click="clickEditPassword">
                <span>修改密码</span>
              </a-menu-item>
               <a-menu-item @click="clickMyAddress">
                <span>我的地址</span>
              </a-menu-item>
              <!-- <a-menu-item @click="clickLogout">
                <span>退出登录</span>
              </a-menu-item> -->
            </a-menu>
          </template>
        </a-dropdown>

        <div class="quit" @click="clickLogout">
          <img src="@/assets/images/quit.png" alt="" width="15" style="margin-right: 2px;">
          退出
        </div>
      </div>
    </div>
  </div>
  <a-modal v-model:visible="data.visible" title="更新密码" :confirm-loading="data.confirmLoading" :destroyOnClose="true"
    :maskClosable="false" @cancel="handleCancel('password')" @ok="handleOk('password')">
    <a-form ref="formRef" :model="data.form" :label-col="{ span: 4 }" autocomplete="off" :rules="rules">
      <a-form-item label="原密码" name="oldPassword">
        <a-input-password v-model:value="data.form.oldPassword" />
      </a-form-item>
      <a-form-item label="新密码" name="password">
        <a-input-password v-model:value="data.form.password" />
      </a-form-item>
      <a-form-item label="确认密码" name="psd">
        <a-input-password v-model:value="data.form.psd" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 修改个人信息 -->
  <personal-info-model ref="personalInfoRef"></personal-info-model>
</template>
<script lang="ts" setup>
import HeaderSelect from "@/components/HeaderSelect/index.vue";
import PersonalInfoModel from "@/components/PersonalInfoModel/index.vue"
import { reactive, ref,onMounted,onBeforeUnmount } from "vue";
import {
  channel,
  checkOldPassword,
  editPassword,
  getPasswordParameters,
  OrderInProgressList,
} from "@/api/api";
import { FormInstance, message, Modal } from "ant-design-vue";
import { passwordValidate } from "@/utils/tool";
import { RuleObject } from "ant-design-vue/lib/form";
import { OUT_LOGIN } from "@/store/types";
import md5 from "js-md5";
import { useStore } from "vuex";
import router from "@/router";
type Form = {
  oldPassword: string;
  password: string;
  psd: string;
};
interface Data {
  dataList: any[];
  tabHoverId: string;
  visible: boolean;
  confirmLoading: boolean;
  form: Form;
  code: string;
  uuid: string;
  receiveTotal: number;
  progressTotal: number
}
const store = useStore();
const formRef = ref<FormInstance>();
const showMobileMenu = ref(false)
const showMobileIcon = ref(false)
const menuContainerRef = ref()
const data: Data = reactive<Data>({
  dataList: [],
  tabHoverId: "",
  visible: false,
  confirmLoading: false,
  code: "",
  uuid: "",
  form: {
    oldPassword: "",
    password: "",
    psd: "",
  },
  receiveTotal: 0,
  progressTotal: 0
});
const toggleMobileMenu=()=> {
    showMobileMenu.value = !showMobileMenu.value;
  }
const checkScreenSize = () => {
  showMobileIcon.value = window.innerWidth < 900;
}
const handleDocumentClick = (event) => {
  // 检查点击是否发生在菜单容器外部
  if (
    showMobileMenu.value &&
    menuContainerRef.value &&
    !menuContainerRef.value.contains(event.target)
  ) {
    showMobileMenu.value = false;
  }
  mouseleaveTab()
}
onMounted(() => {
  checkScreenSize();
  window.addEventListener('resize', checkScreenSize);
  document.addEventListener('click', handleDocumentClick);

})
onBeforeUnmount(() => {
  window.removeEventListener('resize', checkScreenSize);
  document.removeEventListener('click', handleDocumentClick);
})
channel().then((res: any) => {
  data.dataList = res.list.filter((item: { id: number }) => item.id !== 23);
});

// 移入到tab中
const mouseenterTab = (id: string) => {
  data.tabHoverId = id;
};
const clickTab = (id: string) => {
  if(data.tabHoverId === id) return data.tabHoverId = "";
  data.tabHoverId = id;
}
const mouseleaveTab = () => {
  data.tabHoverId = "";
};
// 获取进行中数量
// OrderInProgressList().then((res: any) => {
//   data.progressTotal = res.total_count
// })
// 点击基本资料
const personalInfoRef = ref();
function clickInfo() {
  personalInfoRef.value.visibleInfo = true
}

// 密码检验规则
const psdValidate = (rule: RuleObject, value: string) => {
  if (value === "") {
    return Promise.reject("请输入密码");
  }
  if (value === data.form.password) {
    return Promise.resolve();
  }
  return Promise.reject("与新密码不一致");
};
const rules = {
  oldPassword: [
    { required: true, validator: passwordValidate, trigger: "blur" },
  ],
  password: [{ validator: passwordValidate, trigger: "blur" }],
  psd: [{ validator: psdValidate, trigger: "blur" }],
};
// 点击修改密码
function clickEditPassword() {
  data.visible = true;
  getPsdParameters();
}
//点击我的地址
function clickMyAddress(){
  router.push("/address/List");
}
// 获取加密方式
function getPsdParameters() {
  getPasswordParameters().then((res: any) => {
    data.code = res.code;
    data.uuid = res.uuid;
  });
}
// 点击弹窗确定
function handleOk(type?: string) {
  if (type === "password") {
    // 修改密码弹窗
    formRef.value?.validate().then(() => {
      data.confirmLoading = true;
      // 先验证旧密码是否正确
      const oldPassword = md5(
        md5(
          md5(data.form.oldPassword) +
          data.code +
          md5(data.form.oldPassword)
        ) + data.uuid
      );
      checkOldPassword({
        old_password: oldPassword,
      })
        .then(() => {
          editPassword({
            password: md5(data.form.password),
          })
            .then(() => {
              message.success("更新密码成功");
              location.replace("/login");
              formRef.value?.resetFields();
              data.confirmLoading = false;
              data.visible = false;
            })
            .catch(() => {
              getPsdParameters();
              data.confirmLoading = false;
            });
        })
        .catch(() => {
          getPsdParameters();
          data.confirmLoading = false;
        });
    });
  }
}
// 弹框关闭
function handleCancel(type?: string) {
  if (type === "password") {
    formRef.value?.resetFields();
  }
}
// 点击退出登录
function clickLogout() {
  Modal.confirm({
    title: "即将退出登录，是否继续？",
    closable: true,
    onOk() {
      store.commit(OUT_LOGIN);
      location.replace("/");
    },
  });
}
</script>
<style lang="stylus" scoped>
.layout-header {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0px 0px 0px 20px;
  background-color: #0f5abe;
  height: 70px
}

.login-img {
  flex-shrink: 0;
  img {
    height: 45px
  }
}

.hd-right {
  width: 100%
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #7E7E7E;
  background: #fff;
  padding-right:20px;
  padding-left:25px;
}

.hd-right-icon.justify-end {
  justify-content: flex-end !important;
}

.hd-right-icon.align-start {
  justify-content: flex-end !important;
  align-items: flex-start;
}
.mobile-menu{
  height: auto !important; 
  position: absolute !important;
  background: #fff;
  float: right;
  position: absolute;
  z-index: 2;
  line-height: 36px;
  box-shadow:0 6px 16px 0 rgba(0, 0, 0, 0.08), 
              0 3px 6px -4px rgba(0, 0, 0, 0.12), 
              0 9px 28px 8px rgba(0, 0, 0, 0.05);
  padding:5px;
  flex-direction: column;
  align-items: flex-start !important;
}
.hd-right-ul {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  li {
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 50px;

    a {
      color: #7E7E7E;

      &:hover {
        color: #0f5abe;
      }
    }
  }
}
.hd-right-left {
  display: flex
  align-items: center
}
.icon-div {
  display: flex
  align-items: center
  :deep() .ant-badge-count {
    top: -5px
    right: 16px
    box-shadow: none

  }
  :deep() .ant-badge-multiple-words {
    padding: 0 5px
  }
  .svg-icon {
    font-size: 20px
    margin-right: 20px
  }
}

.hd-right-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 20px;
}
.quit{
   display: flex;
  align-items: center;
  justify-content: content;
  gap:5px;
}
:deep().hd-right-dropdown > .anticon.anticon-down {
  font-size: 14px;
  margin-left: 5px;
  font-weight: bold;
}

.hd-right-user {
  display: flex;
  align-items: center;

  span {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #D4D7D9;
  }
}

</style>
